import { useEffect, useState } from "react";
import { NOTIFICATION_LIFETIME, type Notification } from "../../../context/LayoutContext";
import { X } from "lucide-react";

interface NotificationProps {
    notification: Notification;
    closeNotification: (id: string) => void;
}
export default function Notification({ notification, closeNotification }: NotificationProps) {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
        const timer = setTimeout(() => {
            setIsVisible(false);
            setTimeout(() => closeNotification(notification.id), 300); // Match the CSS transition duration
        }, NOTIFICATION_LIFETIME);

        return () => {
            clearTimeout(timer);
        };
    }, []);

    const prettyClose = () => {
        setIsVisible(false);
        setTimeout(() => closeNotification(notification.id), 300); // Match the CSS transition duration
    };

    return (
        <div
            className={`mb-2 flex w-fit rounded bg-stone-950 pl-3 pr-1 py-2 text-white transition-opacity duration-300 ease-in-out ${isVisible ? "opacity-100" : "opacity-0"}`}
        >
            <div className="ml-auto max-w-sm">{notification.text}</div>
            <button className="p-1" onClick={() => prettyClose()}>
                <X className="h-4 w-4 stroke-stone-500 hover:stroke-stone-100" />
            </button>
        </div>
    );
}
